import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["trigger", "modalContent"];
    elementsToRefresh = "";

    connect() {
        this.element[this.identifier] = this;
        this.initializeTriggers();

        this.modal = document.getElementById("ajax-modal");
        this.pendingUrl = "";

        this.handleDocumentClick = (event) => {
            const el = event.target && event.target.closest('[data-ajax-modal-target="trigger"]');
            if (!el) return;
            // Ensure this controller handles the click
            event.preventDefault();
            this.pendingUrl = el.href;
            this.setContentLoaderUrl(this.pendingUrl);
        };
        document.addEventListener('click', this.handleDocumentClick, true);

        if (!this.modal) return;

        this.modal.addEventListener("hidden.bs.modal", (event) => {
            this.setContentLoaderUrl("");
            if (this.contentLoader()) this.contentLoader().lazyLoad();
            if (this.modalContentTarget)
                this.modalContentTarget.innerHTML = '<i className="fas fa-spinner fa-spin"></i>';

            this.refreshBackgroundElements();
        });

        this.modal.addEventListener("shown.bs.modal", (event) => {
            if (this.pendingUrl) {
                this.setContentLoaderUrl(this.pendingUrl);
            }
            const loader = this.contentLoader();
            if (loader && typeof loader.fetch === "function") {
                loader.fetch();
            }
        });

        // Attendre le chargement du contenu avant d'appliquer la classe et exécuter les scripts
        const target = this.modalContentTarget || (this.modal && this.modal.querySelector('[data-ajax-modal-target="modalContent"]'));
        if (target) {
            const onLoaded = () => {
                this.setModalClass();
                this.executeModalScripts();
            };
            target.addEventListener('content-loader:loaded', onLoaded);
        }

    }

    disconnect() {
        if (this.handleDocumentClick) {
            document.removeEventListener('click', this.handleDocumentClick, true);
        }
    }

    executeModalScripts() {
        if (!this.modalContentTarget) return;
        this.modalContentTarget.querySelectorAll("script[data-modal-script]").forEach((script) => {
            const newScript = document.createElement("script");
            newScript.textContent = script.textContent;
            document.body.appendChild(newScript);
            script.remove();
        });
    }

    setModalClass() {
        if (!this.modal) return;
        const dialog_class_element = this.modal.querySelector("[data-modal-dialog-class]");
        if (dialog_class_element) {
            const dialog_class = dialog_class_element.dataset.modalDialogClass;
            this.modal
                .querySelector(".modal-dialog")
                .setAttribute("class", "modal-dialog " + dialog_class);
        }
    }

    initializeTrigger(event) {
        if (event && typeof event.preventDefault === "function") {
            event.preventDefault();
        }
        const source = (event.currentTarget && event.currentTarget.source) || this;
        if (!source || typeof source.setContentLoaderUrl !== "function") return;
        const href = event.currentTarget && event.currentTarget["href"];
        source.pendingUrl = href;
        source.setContentLoaderUrl(href);
        source.elementsToRefresh =
            (event.currentTarget && event.currentTarget.getAttribute("data-ajax-modal-refresh-selectors")) || "";

        // Trigger immediate fetch so the request starts right away
        if (typeof source.contentLoader === "function") {
            const loader = source.contentLoader();
            if (loader && typeof loader.fetch === "function") {
                loader.fetch();
            }
        }
    }

    initializeTriggers() {
        this.triggerTargets.forEach((element) => {
            element.setAttribute("data-bs-toggle", "modal");
            element.setAttribute("data-bs-target", "#ajax-modal");
            // Bootstrap 4 compatibility
            element.setAttribute("data-toggle", "modal");
            element.setAttribute("data-target", "#ajax-modal");

            element.source = this;
            // bind to preserve 'this'
            const bound = (e) => this.initializeTrigger(e);
            element.removeEventListener("click", bound);
            element.addEventListener("click", bound);
        });
    }

    setContentLoaderUrl(url) {
        let targetEl = this.modalContentTarget ||
            (this.modal && this.modal.querySelector('[data-ajax-modal-target="modalContent"]')) ||
            document.querySelector('#ajax-modal [data-ajax-modal-target="modalContent"]');
        if (targetEl) {
            targetEl.setAttribute("data-content-loader-url-value", url);
            // keep dataset in sync (Stimulus values parsing)
            targetEl.dataset.contentLoaderUrlValue = url;
        }
        // Also set Stimulus value on the loader if present
        const loader = this.contentLoader() || (targetEl && targetEl["content-loader"]);
        if (loader) {
            try {
                loader.urlValue = url;
            } catch (_) {}
        }
    }

    async refreshBackgroundElements() {
        if (this.elementsToRefresh == "") return;

        let response = await fetch(document.location.href);
        let html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        this.elementsToRefresh.split(",").forEach(function(selector) {
            const newEl = doc.querySelector(selector);
            const oldEl = document.querySelector(selector);
            if (newEl && oldEl) oldEl.outerHTML = newEl.outerHTML;
        });

        this.initializeTriggers();
    }

    contentLoader() {
        return this.modalContentTarget && this.modalContentTarget["content-loader"];
    }
}